module.exports = __webpack_public_path__ + "img/BOT-icon.a14b3cbe.svg";